import ChatViewClient from './ChatViewClient';

export default ChatViewClient;